import { render, staticRenderFns } from "./taxInfo.vue?vue&type=template&id=52c4b2e6&scoped=true&"
import script from "./taxInfo.vue?vue&type=script&lang=js&"
export * from "./taxInfo.vue?vue&type=script&lang=js&"
import style0 from "./taxInfo.vue?vue&type=style&index=0&id=52c4b2e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4b2e6",
  null
  
)

export default component.exports